@if (isInviteRoute()) {
	<router-outlet></router-outlet>
} @else if (auth.isAccountDisabled) {
	<lib-account-disabled></lib-account-disabled>
} @else if (!storeService.connectedUser || (companySwitcher.isSwitchingCompany$ | async)) {
	<div class="d-flex align-items-center justify-content-center" style="height: 100%">
		<uik-spinner></uik-spinner>
	</div>
} @else {
	<app-portal></app-portal>
}
